"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcContractStatusCard = exports.ContractStatusTransition = void 0;
const ContractStatusTransition_yaml_component_1 = __importDefault(require("./ContractStatusTransition.yaml?component"));
exports.ContractStatusTransition = ContractStatusTransition_yaml_component_1.default;
const UcContractStatusCard_yaml_component_1 = __importDefault(require("./UcContractStatusCard.yaml?component"));
exports.UcContractStatusCard = UcContractStatusCard_yaml_component_1.default;
